@if (corporateTaxEntity$ | async) {
  <form [formGroup]="voegingFg">
    <div class="row">
      <div formArrayName="voeging">
        @for (item of voeging.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Naam gevoegde dochter' : ''"
              [required]="true"
              class="custom-input-250"
              formControlName="naamDochtervennootschap"
              id="naamDochtervennootschap"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Belaste vrijval dochter' : ''"
              [required]="true"
              [showAllDecimals]="false"
              align="right"
              class="custom-input-150"
              formControlName="belasteVrijvalSchuldBijDochter"
              id="belasteVrijvalSchuldBijDochter"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Belaste vrijval moeder' : ''"
              [required]="true"
              [showAllDecimals]="false"
              align="right"
              class="custom-input-150"
              formControlName="belasteVrijvalSchuldAndereMaatschappij"
              id="belasteVrijvalSchuldAndereMaatschappij"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Vermogenssprong' : ''"
              [required]="true"
              [showAllDecimals]="false"
              align="right"
              class="custom-input-150"
              formControlName="vermogenssprongMoederBijVoeging"
              id="vermogenssprongMoederBijVoeging"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button
              (click)="showDialog()"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="plus"
              type="secondary"
            >Meer gegevens
            </snelstart-ui-button>
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'pt-3' : ''"
              class="delete"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    id="cancel"
    class="snelstart-ui-button pb-3"
    icon="plus"
    type="link"
  >Vennootschap toevoegen
  </snelstart-ui-button>
}
